import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import api from '@/constant/END_POINT'

type SendRequestDocumentNotificationPayload = {
  claimFormId: string
  phoneNumber: string
}

const postSendRequestDocumentNotification = async ({
  claimFormId,
  phoneNumber,
}: SendRequestDocumentNotificationPayload) => {
  const response = await httpClientPrivate.post(
    api.backoffice.sendRequestDocumentNotification,
    {
      claimFormId,
      phoneNumber,
    },
  )

  return response.data
}

const useSendRequestDocumentNotification = () => {
  const mutation = useMutation({
    mutationKey: ['useSendRequestDocumentNotification'],
    mutationFn: (payload: SendRequestDocumentNotificationPayload) =>
      postSendRequestDocumentNotification(payload),
  })

  return mutation
}

export { useSendRequestDocumentNotification }
